import {
  Connection,
  isDatabaseProvider,
  NotTestableProviders,
} from "src/api/connectApi/types";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

export const getTestableStatus = (connection: Connection) => {
  // Any manifest-based integration currently doesn’t support probing.
  if (connection.manifest_version) {
    return "untestable";
  }
  if (connection.provider === "webhook" || connection.provider === "retool") {
    return "untestable";
  }

  if (connection.provider === "custom") {
    const hasProductionProbeURL = Boolean(
      connection.configuration.probe_url &&
        connection.configuration.probe_url.trim(),
    );

    const hasSandboxProbeURL = Boolean(
      connection.enable_non_prod_configs &&
        connection.non_prod_env_configs?.sandbox?.probe_url &&
        connection.non_prod_env_configs?.sandbox?.probe_url.trim(),
    );

    return hasProductionProbeURL || hasSandboxProbeURL
      ? "testable"
      : "untestable_lacks_probe_url";
  }

  if (connection.configuration.multi_tenant) {
    // Temporary not allowing the multi-tenant connections
    // to be tested while we figure out how exactly it should work
    return "untestable";
  } else {
    return NotTestableProviders.includes(connection.provider)
      ? "untestable"
      : "testable";
  }
};

export const getConnectionType = (connection: Connection) => {
  if (connection.metadata?.is_elements_integration) {
    return "Elements";
  } else if (connection.provider === "custom") {
    return "Custom Connection";
  } else if (connection.provider === "webhook") {
    return "Inbound Webhook";
  } else if (isDatabaseProvider(connection.provider)) {
    return "Database";
  } else if (
    connection.manifest_version &&
    isFeatureFlagEnabled(FEATURE_FLAGS.powertools)
  ) {
    return "Manifest Integration";
  } else {
    return "Integration";
  }
};
